import React from 'react'
import constants from '../assets/constants'
import RowComponent from './CardRiepilogoRow'
import _ from 'lodash'

const RiepilogoCardDettagli = (props) => {
  const tipologia = _.get(constants.tipologie, props.formValue.tipologia)
  const bagni = _.get(
    _.find(
      constants.numeroBagni,
      (item) => item.value === props.formValue.numeroBagni
    ),
    'label',
    ''
  )
  const postiLetto = _.get(
    _.find(
      constants.numeroPostiLetto,
      (item) => item.value === props.formValue.numeroPostiLetto
    ),
    'label',
    ''
  )
  const camereLetto = _.get(
    _.find(
      constants.numeroCamereLetto,
      (item) => item.value === props.formValue.numeroCamereLetto
    ),
    'label',
    ''
  )
  const coinquilini = _.get(
    _.find(
      constants.numeroCoinquilini,
      (item) => item.value === props.formValue.numeroCoinquilini
    ),
    'label',
    ''
  )
  const sesso = _.get(
    _.find(constants.gender, (item) => item.value === props.formValue.sesso),
    'label',
    ''
  )
  const piano = _.get(
    _.find(constants.piani, (item) => item.value === props.formValue.piano),
    'label',
    ''
  )
  const extras = _(constants.extra)
    .filter((item) => _.includes(props.formValue.extra, item.value))
    .map((item) => item.label)
    .value()
  const furniture = _(constants.furniture)
    .filter((item) => _.includes(props.formValue.furniture, item.value))
    .map((item) => item.label)
    .value()
  return (
    <>
      <RowComponent
        testo={
          <span>
            Voglio affittare un <strong>{tipologia}</strong>
            {postiLetto && (
              <span>
                {' '}
                - <strong>{postiLetto}</strong>
              </span>
            )}
            {bagni && (
              <span>
                {' '}
                - <strong>{bagni}</strong>
              </span>
            )}
            {camereLetto && (
              <span>
                {' '}
                - <strong>{camereLetto}</strong>
              </span>
            )}
            {coinquilini && (
              <span>
                {' '}
                - <strong>{coinquilini}</strong>
              </span>
            )}
          </span>
        }
        onIconClick={() => props.goToStep(0, 0)}
      />
      {sesso && (
        <RowComponent
          testo={
            <span>
              Preferisco affitare a <strong>{sesso}</strong>
            </span>
          }
          onIconClick={() => props.goToStep(2, 0)}
        />
      )}
      <RowComponent
        testo={
          <span>
            L'appartamento è in{' '}
            <strong>
              {props.formValue.indirizzo} - {props.formValue.CAP} -{' '}
              {props.formValue.citta}
            </strong>
          </span>
        }
        onIconClick={() => props.goToStep(3, 0)}
      />
      <RowComponent
        testo={
          <span>
            Si trova al <strong>{piano}</strong>
          </span>
        }
        onIconClick={() => props.goToStep(4, 0)}
      />
      {_.size(props.formValue.extra) > 0 ? (
        <RowComponent
          testo={
            <span>
              L'appartamento ha <strong>{_.join(extras, ', ')}</strong>
            </span>
          }
          onIconClick={() => props.goToStep(4, 0)}
        />
      ) : (
        <RowComponent
          testo={
            <span>
              <span className='text-warning'>L'appartamento ha:</span>
              <span className='text-gray-400'> - non specificato</span>
            </span>
          }
          onIconClick={() => props.goToStep(4, 0)}
        />
      )}
      {_.size(props.formValue.furniture) > 0 ? (
        <RowComponent
          testo={
            <span>
              L'appartamento ha <strong>{_.join(furniture, ', ')}</strong>
            </span>
          }
          onIconClick={() => props.goToStep(5, 0)}
        />
      ) : (
        <RowComponent
          testo={
            <span>
              <span className='text-warning'>Forniture dell'appartamento:</span>
              <span className='text-gray-400'> - non specificato</span>
            </span>
          }
          onIconClick={() => props.goToStep(5, 0)}
        />
      )}
    </>
  )
}

export default RiepilogoCardDettagli
